// Mock data for Reachly - all functionality is frontend-only until backend integration

export const BRAND = {
  name: 'Reachly',
  tagline: 'The job seeker\'s cold outreach machine.',
  description: 'Land interviews faster. Build multi-step email campaigns to recruiters and hiring managers, automate follow-ups, and track every reply — from your own Outlook inbox.'
};

export const mockUser = {
  id: 'u_1',
  name: 'Alex Morgan',
  email: 'alex.morgan@example.com',
  avatar: null,
  outlookConnected: false,
  plan: 'Pro',
  dailyLimit: 100,
  sentToday: 23,
};

export const mockStats = {
  totalContacts: 148,
  activeCampaigns: 3,
  emailsSent: 412,
  openRate: 61.4,
  replyRate: 12.8,
  bounceRate: 2.1,
};

export const mockContacts = [
  { id: 'c1', firstName: 'Jamie', lastName: 'Chen', email: 'jamie.chen@stripe.com', phone: '+1 415 555 0198', company: 'Stripe', jobTitle: 'Senior Recruiter', status: 'contacted', campaignId: 'cmp1', lastActivity: '2 days ago' },
  { id: 'c2', firstName: 'Priya', lastName: 'Sharma', email: 'priya@airbnb.com', phone: '+1 415 555 0134', company: 'Airbnb', jobTitle: 'Engineering Manager', status: 'replied', campaignId: 'cmp1', lastActivity: '5 hours ago' },
  { id: 'c3', firstName: 'Marcus', lastName: 'Weber', email: 'marcus.weber@figma.com', phone: '', company: 'Figma', jobTitle: 'Head of Talent', status: 'awaiting_followup', campaignId: 'cmp1', lastActivity: '1 day ago' },
  { id: 'c4', firstName: 'Elena', lastName: 'Rossi', email: 'elena.r@notion.so', phone: '+1 628 555 0201', company: 'Notion', jobTitle: 'Technical Recruiter', status: 'queued', campaignId: 'cmp2', lastActivity: 'never' },
  { id: 'c5', firstName: 'David', lastName: 'Park', email: 'dpark@openai.com', phone: '+1 415 555 0177', company: 'OpenAI', jobTitle: 'Recruiting Lead', status: 'bounced', campaignId: 'cmp1', lastActivity: '3 days ago' },
  { id: 'c6', firstName: 'Sara', lastName: 'Okoye', email: 'sara.okoye@vercel.com', phone: '', company: 'Vercel', jobTitle: 'Hiring Manager', status: 'queued', campaignId: 'cmp2', lastActivity: 'never' },
  { id: 'c7', firstName: 'Tom', lastName: 'Nakamura', email: 't.nakamura@linear.app', phone: '+1 628 555 0344', company: 'Linear', jobTitle: 'CTO', status: 'contacted', campaignId: 'cmp3', lastActivity: '4 hours ago' },
  { id: 'c8', firstName: 'Rachel', lastName: 'Klein', email: 'rachel@anthropic.com', phone: '', company: 'Anthropic', jobTitle: 'People Ops Lead', status: 'awaiting_followup', campaignId: 'cmp3', lastActivity: '18 hours ago' },
];

export const mockCampaigns = [
  {
    id: 'cmp1',
    name: 'Series-B Startups Outreach',
    status: 'active',
    contactCount: 42,
    sent: 128,
    opens: 84,
    replies: 17,
    bounces: 3,
    createdAt: '2025-01-08',
    steps: [
      { id: 's1', order: 1, delayDays: 0, subject: 'Interested in {{job_title}} opportunities at {{company}}', body: 'Hi {{first_name}},\n\nI came across {{company}} and was really impressed by your recent product launch. I\'m a senior engineer with 7 years of experience shipping production systems — would love to chat about the {{job_title}} role.\n\nAttached is a short profile. Open to a 15-min call this week?\n\nBest,\nAlex', templateId: 't1' },
      { id: 's2', order: 2, delayDays: 3, subject: 'Re: {{job_title}} at {{company}}', body: 'Hi {{first_name}},\n\nJust bumping this up in case my previous note got buried. Would love to hear if there\'s a fit at {{company}}.\n\nBest,\nAlex', templateId: 't2' },
      { id: 's3', order: 3, delayDays: 7, subject: 'Last note — {{company}}', body: 'Hi {{first_name}},\n\nCompletely understand if timing isn\'t right. If you know of another team hiring, I\'d appreciate a pointer. Otherwise, wishing you a great week.\n\nAlex', templateId: 't3' },
    ],
  },
  {
    id: 'cmp2',
    name: 'FAANG Recruiters',
    status: 'draft',
    contactCount: 18,
    sent: 0, opens: 0, replies: 0, bounces: 0,
    createdAt: '2025-01-14',
    steps: [
      { id: 's4', order: 1, delayDays: 0, subject: 'Warm intro — {{first_name}}', body: 'Hi {{first_name}}, ...', templateId: 't1' },
    ],
  },
  {
    id: 'cmp3',
    name: 'AI Startups — SF',
    status: 'active',
    contactCount: 27,
    sent: 54, opens: 41, replies: 9, bounces: 1,
    createdAt: '2025-01-11',
    steps: [
      { id: 's5', order: 1, delayDays: 0, subject: 'ML engineer at {{company}}?', body: 'Hi {{first_name}}, ...', templateId: 't4' },
      { id: 's6', order: 2, delayDays: 4, subject: 'Following up', body: 'Hey {{first_name}}, ...', templateId: 't2' },
    ],
  },
];

export const mockTemplates = [
  { id: 't1', name: 'Warm Intro', subject: 'Interested in {{job_title}} opportunities at {{company}}', body: 'Hi {{first_name}},\n\nI came across {{company}} and was really impressed...', updatedAt: '2025-01-10' },
  { id: 't2', name: 'First Follow-up', subject: 'Re: {{job_title}} at {{company}}', body: 'Hi {{first_name}},\n\nJust bumping this up...', updatedAt: '2025-01-10' },
  { id: 't3', name: 'Break-up Note', subject: 'Last note — {{company}}', body: 'Hi {{first_name}},\n\nCompletely understand if timing isn\'t right...', updatedAt: '2025-01-09' },
  { id: 't4', name: 'Referral Ask', subject: 'Quick favor, {{first_name}}?', body: 'Hi {{first_name}}, would you be open to referring me...', updatedAt: '2025-01-06' },
];

export const statusMeta = {
  queued: { label: 'Queued', color: 'bg-zinc-800 text-zinc-300 border-zinc-700' },
  contacted: { label: 'Contacted', color: 'bg-blue-950 text-blue-300 border-blue-900' },
  awaiting_followup: { label: 'Awaiting Follow-up', color: 'bg-amber-950 text-amber-300 border-amber-900' },
  replied: { label: 'Replied', color: 'bg-emerald-950 text-emerald-300 border-emerald-900' },
  bounced: { label: 'Bounced', color: 'bg-red-950 text-red-300 border-red-900' },
  missing_data: { label: 'Missing data', color: 'bg-orange-950 text-orange-300 border-orange-900' },
};

export const competitors = [
  { slug: 'apollo', name: 'Apollo.io', tagline: 'B2B sales intelligence platform', pricing: 'From $49/mo', freeOption: true, bestFor: 'Sales teams doing outbound at scale', keyStrengths: ['Massive B2B database','Built-in dialer','Full CRM'], weaknesses: ['Overkill for job seekers','Steep learning curve','Costly at higher tiers'] },
  { slug: 'zoominfo', name: 'ZoomInfo', tagline: 'Enterprise contact database', pricing: 'From $14,995/yr', freeOption: false, bestFor: 'Enterprise sales & recruiting teams', keyStrengths: ['Deepest data','Intent signals','Enterprise integrations'], weaknesses: ['Enterprise-only pricing','Not for individuals','Long contracts'] },
  { slug: 'lusha', name: 'Lusha', tagline: 'Contact finder browser extension', pricing: 'From $29/mo', freeOption: true, bestFor: 'Individual recruiters and SDRs', keyStrengths: ['Simple UX','Fast Chrome extension','Freemium'], weaknesses: ['No campaign engine','Limited follow-up automation','Credits burn fast'] },
  { slug: 'rocketreach', name: 'RocketReach', tagline: 'Email & phone lookup', pricing: 'From $39/mo', freeOption: true, bestFor: 'Prospecting & one-off lookups', keyStrengths: ['Broad coverage','LinkedIn & GitHub search','API access'], weaknesses: ['No sequences','No CV parsing','No Outlook sync'] },
  { slug: 'hunter', name: 'Hunter.io', tagline: 'Email finding & verification', pricing: 'From $34/mo', freeOption: true, bestFor: 'Finding company emails at scale', keyStrengths: ['Domain search','Free tier','Verification'], weaknesses: ['Only email (no phone)','Basic outreach tool','Not job-seeker focused'] },
  { slug: 'kaspr', name: 'Kaspr', tagline: 'LinkedIn contact extractor', pricing: 'From $45/mo', freeOption: true, bestFor: 'LinkedIn-heavy prospecting', keyStrengths: ['Chrome extension','GDPR-compliant','LinkedIn native'], weaknesses: ['Europe-focused data','Limited sequencing','No CV import'] },
  { slug: 'contactout', name: 'ContactOut', tagline: 'Recruiter contact finder', pricing: 'From $99/mo', freeOption: true, bestFor: 'Corporate recruiters', keyStrengths: ['Recruiter-first UX','Chrome extension','ATS integrations'], weaknesses: ['Not built for job seekers','Expensive for individuals','Weak follow-up automation'] },
];

// Comparison matrix for Reachly vs each
export const reachlyVsMatrix = {
  reachly: {
    price: 'Free · Pro $19/mo',
    freeOption: true,
    campaignSequences: 'Unlimited steps',
    followupAutomation: 'Auto (15-min cron)',
    replyDetection: 'Native, pauses sequence',
    outlookNative: true,
    cvParsing: 'AI-powered (PDF/DOCX)',
    csvImport: true,
    analytics: 'Per-campaign + global',
    bestFor: 'Job seekers doing cold outreach',
  },
};

export const faqsPerCompetitor = (competitorName) => [
  { q: `Is Reachly a good ${competitorName} alternative?`, a: `Yes — if your primary use case is job-search outreach rather than B2B sales, Reachly is built specifically for that workflow. It focuses on multi-step sequences to recruiters and hiring managers, native Outlook sending, and CV import, at a fraction of ${competitorName}\'s price.` },
  { q: `${competitorName} vs Reachly — which is better?`, a: `${competitorName} shines for sales teams needing a massive B2B database and CRM. Reachly wins for individual job seekers who need automated follow-ups from their own Outlook inbox, CV/CSV contact import, and honest analytics — without paying enterprise prices.` },
  { q: `Can I import my contacts from ${competitorName} into Reachly?`, a: `Yes. Export your contacts from ${competitorName} as CSV and upload them to Reachly — our parser auto-maps fields (name, email, phone, company, title) and gives you a review screen before anyone is added to a campaign.` },
  { q: 'Does Reachly send emails from my own inbox?', a: 'Yes. Reachly connects to Outlook via Microsoft OAuth so every email is sent directly from your address, replies land in your normal inbox, and you keep full deliverability and warm sending reputation.' },
];

export const landingTestimonials = [
  { name: 'Priya M.', role: 'ML Engineer · offer at Anthropic', quote: 'I ran a 30-contact sequence to AI startups. Got 6 interviews in 2 weeks. Would\'ve taken me a month manually.' },
  { name: 'Jordan L.', role: 'PM · offer at Stripe', quote: 'The auto follow-ups did the work. Recruiters replied to my second email more than the first.' },
  { name: 'Sam K.', role: 'Senior Designer · offer at Figma', quote: 'CV upload extracted my target contacts in seconds. Set up my first campaign in 10 minutes.' },
];

export const landingFeatures = [
  { icon: 'Mail', title: 'Multi-step sequences', desc: 'Initial email + automatic follow-ups. Stops instantly the moment someone replies.' },
  { icon: 'Inbox', title: 'Native Outlook sending', desc: 'Connect your Outlook account. Emails go from you, replies come to you.' },
  { icon: 'FileUp', title: 'CV & CSV parsing', desc: 'Drop a resume or a contact list. AI extracts names, emails, phones, companies.' },
  { icon: 'BarChart3', title: 'Real reply analytics', desc: 'Opens, replies, bounces per campaign. Know what\'s working, ship the next.' },
  { icon: 'Zap', title: 'Smart throttling', desc: 'Daily sending caps and human-like pacing keep your account healthy.' },
  { icon: 'Users', title: 'Contact command center', desc: 'One dashboard: queued, contacted, awaiting, replied, bounced. Total control.' },
];

export { personalize, resolveVariables } from '../lib/personalize';
